module.exports = __webpack_public_path__ + "141d4a85/img/saly-icon.39e12342.jpg";